import React, { forwardRef, useState } from "react";
import classNames from "classnames";

import { useAnalyticsFilter } from "../../context/AnalyticsFilterContext";
import ExportData from "./export-data";
import { handleExportPdf, handleExportPng } from "../../utils/functions";
import DropDown from "../../components/dropdown";

import Icon from "../../assets/svg";
import DatePickerComponent from "../../components/datepicker";
import Button from "../../components/button";
import moment from "moment";

// No extra props beyond the forwarded ref
type AnalyticsFilterProps = {
  disableActions: boolean;
  getMetrics?: (params: { start: string; end: string }) => void;
};

const AnalyticsFilter = forwardRef<HTMLDivElement, AnalyticsFilterProps>(
  function AnalyticsFilter({ disableActions, getMetrics }, metricRef) {
    const { durationList, duration, setDuration } = useAnalyticsFilter();

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const exportOptions = [
      {
        name: "PDF",
        action: () =>
          metricRef &&
          "current" in metricRef &&
          metricRef.current &&
          handleExportPdf(metricRef.current, "konvasAI-campaigns-metric.pdf"),
      },
      {
        name: "Image(PNG)",
        action: () =>
          metricRef &&
          "current" in metricRef &&
          metricRef.current &&
          handleExportPng(metricRef.current, "konvasAI-campaigns-metric.png"),
      },
    ];

    const handleFilter = () => {
      const start_date = moment(startDate).format("YYYY-MM-DD h:mm:ss");
      const end_date = moment(endDate).format("YYYY-MM-DD h:mm:ss");
      const params = {
        start: start_date,
        end: end_date,
      };
      getMetrics?.(params);
    };

    return (
      <div className="analytics_filter">
        <div className="left">
          {durationList.map((data, index) => (
            <div
              key={data.value}
              className={classNames("duration", {
                last: index === durationList.length - 1,
                active: data.value === duration,
              })}
              onClick={() => setDuration(data.value)}
            >
              <p>{data.name}</p>
            </div>
          ))}
        </div>
        <div className="right">
          <ExportData exportOptions={exportOptions} disabled={disableActions} />

          <div className="filter_by_date_container">
            <DropDown
              toggler={
                <div
                  className={classNames("filter_by_date", {
                    disabled: disableActions,
                  })}
                >
                  <Icon name="calendar" />
                  <p>Filter by date</p>
                </div>
              }
            >
              {!disableActions && (
                <div className="date">
                  <div className="datepicker">
                    <DatePickerComponent
                      startDate={startDate}
                      endDate={endDate}
                      text="Click here to select date"
                      onChange={(update: any) => {
                        setDateRange(update);
                      }}
                      maxDate={new Date()}
                      range={true}
                    />
                  </div>

                  <Button
                    text="Search"
                    onClick={handleFilter}
                    disabled={!(startDate && endDate)}
                  />
                </div>
              )}
            </DropDown>
          </div>
        </div>
      </div>
    );
  }
);

export default AnalyticsFilter;
